export const siteInfo = {
  name: '爱漫画网',
  h1: '爱漫画网 · 你的追漫第一站',
  preTags: '韩漫推荐 · 日漫大全 · 国漫排行榜',
  slogan: '热门排行实时更新 · 免费在线畅读完整版',
  description: '爱漫画网专注韩漫推荐、日漫大全与国漫排行榜，每日实时更新热门漫画排行和最新漫画连载。无论你是韩漫爱好者、日漫铁粉还是国漫追随者，这里都有最全的漫画大全等你探索。全站漫画免费在线观看，分类清晰、更新及时，找漫追漫从未如此轻松。当前全站已收录超过 30,000 部漫画作品，覆盖热血、恋爱、奇幻、悬疑、搞笑等全品类，是漫画爱好者不可错过的在线漫画阅读平台。',
  stats: [
    { label: '收录漫画', value: '30,000+' },
    { label: '每日更新', value: '200+' },
    { label: '活跃漫迷', value: '500万+' },
  ],
};

export const updates = [
  {
    date: '2026-07-28',
    tag: '韩漫',
    title: '《我独自升级》第二季动画定档2026年秋季，官方发布首支预告片',
  },
  {
    date: '2026-07-27',
    tag: '日漫',
    title: '《咒术回战》最终章人气投票结果揭晓，五条悟蝉联榜首',
  },
  {
    date: '2026-07-26',
    tag: '韩漫',
    title: '《剑尊归来》第178话更新：华山派大战一触即发，剧情迎来高潮',
  },
  {
    date: '2026-07-25',
    tag: '国漫',
    title: '《镖人》动画电影票房突破8亿，国漫改编再创佳绩',
  },
  {
    date: '2026-07-24',
    tag: '韩漫',
    title: '《全知读者视角》漫画版突破500话，阅读量突破10亿次',
  },
  {
    date: '2026-07-23',
    tag: '日漫',
    title: '《葬送的芙莉莲》第二季制作决定，预计2027年开播',
  },
  {
    date: '2026-07-22',
    tag: '国漫',
    title: '《星辰变》第六季定档，新海报曝光引发漫迷热议',
  },
];

export const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量漫画库',
    desc: '收录超过 30,000 部韩漫、日漫、国漫作品，涵盖热血、恋爱、奇幻、悬疑、搞笑等全品类，热门漫画排行一目了然。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日同步更新',
    desc: '热门连载与日韩同步追更，每天 200+ 话最新漫画连载准时上线，不错过任何精彩剧情。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费畅读',
    desc: '全站漫画免费在线观看，无隐藏收费、无章节限制，高清画质流畅阅读体验。',
  },
  {
    icon: 'ri-ai-generate',
    title: '智能个性推荐',
    desc: '根据你的阅读偏好精准推荐韩漫推荐、日漫大全相关内容，越读越懂你的追漫口味。',
  },
];

export const carouselItems = [
  {
    title: '韩漫精选：从《我独自升级》到《全知读者视角》',
    desc: '韩漫近年以精良画风和紧凑剧情席卷全球，本专题精选20部必看韩漫推荐作品，从热血战斗到浪漫恋爱，每一部都值得反复品读。',
    imageSeq: 'carousel-kr',
    query: 'Artistic illustration of Korean webtoon style with vibrant colors dynamic action scenes fantasy warriors and romantic characters floating manga panels warm golden and coral tones editorial composition high detail stylized',
  },
  {
    title: '日漫经典：那些年我们追过的神作',
    desc: '从《海贼王》到《咒术回战》，日漫大全收录跨越数十年的经典作品。本专题带你重温那些改变漫画史的伟大作品，感受日漫不朽的魅力。',
    imageSeq: 'carousel-jp',
    query: 'Artistic illustration of classic Japanese manga aesthetics with samurai ninja school life scenes iconic manga panel layouts warm nostalgic lighting cream background stylized editorial composition with soft shadows',
  },
  {
    title: '国漫崛起：新时代的东方美学',
    desc: '国漫排行榜上的作品正在用独特的东方美学征服全球读者。从《镖人》到《星辰变》，国漫正以惊人速度崛起，本专题为你呈现最强国漫阵容。',
    imageSeq: 'carousel-cn',
    query: 'Artistic illustration of Chinese manhua style with traditional ink wash painting elements martial arts xianxia fantasy characters dynamic brushstroke aesthetics warm earthy tones editorial composition',
  },
  {
    title: '新番速递：2026夏季必追连载清单',
    desc: '每个季度都有大量新作上线，我们为你整理本季最值得追的最新漫画连载，从悬疑推理到甜蜜恋爱，总有一部适合你。',
    imageSeq: 'carousel-new',
    query: 'Artistic illustration of fresh new manga releases with colorful covers summer themed bright vibrant energy floating book covers warm sunlight clean modern editorial composition with inviting atmosphere',
  },
];

export const comments = [
  {
    avatar: '迷途的小猫',
    date: '2天前',
    content: '在爱漫画网追《全知读者视角》快一年了，更新速度真的快，画质也很清晰。每天打开网站看最新漫画连载已经成了习惯，推荐给了好多朋友！',
    manga: '《全知读者视角》',
    tag: '韩漫推荐',
  },
  {
    avatar: '风间彻',
    date: '3天前',
    content: '日漫大全的分类做得很细致，找老番特别方便。最近在重温《钢之炼金术师》，评论区还有很多同好一起讨论，氛围特别好。',
    manga: '《钢之炼金术师》',
    tag: '日漫大全',
  },
  {
    avatar: '墨染青衣',
    date: '5天前',
    content: '作为一个国漫粉，看到国漫排行榜上越来越多优秀作品真的很开心。《镖人》的推荐就是在这里看到的，画风和故事都超出预期！',
    manga: '《镖人》',
    tag: '国漫排行榜',
  },
  {
    avatar: '夜雨声烦',
    date: '1周前',
    content: '热门漫画排行每周都在变化，每次来都能发现新宝藏。免费漫画在线看真的很良心，没有广告打扰，阅读体验一流。',
    manga: '《剑尊归来》',
    tag: '热门漫画排行',
  },
];

export const rankings = [
  { rank: 1, title: '我独自升级', author: 'Chugong / DUBU', genre: '韩漫·热血', score: '9.8', desc: '从最弱猎人到最强之王，逆袭之路燃爆全场' },
  { rank: 2, title: '全知读者视角', author: 'sing N song / Sleepy-C', genre: '韩漫·奇幻', score: '9.7', desc: '小说变成现实的末世求生，智斗巅峰之作' },
  { rank: 3, title: '咒术回战', author: '芥见下下', genre: '日漫·战斗', score: '9.6', desc: '诅咒与咒术的激斗，角色塑造深入人心' },
  { rank: 4, title: '镖人', author: '许先哲', genre: '国漫·武侠', score: '9.5', desc: '硬派武侠画风，隋末江湖的刀光剑影' },
  { rank: 5, title: '剑尊归来', author: 'Cheongcho / LICO', genre: '韩漫·玄幻', score: '9.4', desc: '剑尊重生归来，华山派再铸辉煌' },
];

export const topics = [
  { name: '韩漫推荐', count: '12.8万', hot: true },
  { name: '日漫大全', count: '10.5万', hot: true },
  { name: '国漫排行榜', count: '8.6万', hot: true },
  { name: '热血战斗', count: '7.2万', hot: false },
  { name: '恋爱甜漫', count: '6.9万', hot: false },
  { name: '奇幻冒险', count: '5.4万', hot: false },
  { name: '悬疑推理', count: '4.8万', hot: false },
  { name: '搞笑日常', count: '4.2万', hot: false },
  { name: '新番速递', count: '3.7万', hot: true },
  { name: '完结神作', count: '3.1万', hot: false },
];

export const faqs = [
  {
    q: '爱漫画网的漫画都是免费的吗？',
    a: '是的，爱漫画网所有漫画内容均免费在线观看，无需付费订阅。无论是韩漫推荐、日漫大全还是国漫排行榜中的热门漫画排行，都可以免费畅读完整版，无章节限制。',
  },
  {
    q: '最新漫画连载多久更新一次？',
    a: '我们与各大平台保持同步，每日更新 200+ 话最新漫画连载。热门漫画通常在官方发布后数小时内即可在爱漫画网阅读，韩漫和日漫的更新频率尤其稳定。',
  },
  {
    q: '如何在手机上阅读漫画？',
    a: '爱漫画网采用响应式设计，可直接在手机浏览器中访问。页面自动适配手机屏幕，提供流畅的竖屏阅读体验。我们也提供移动端专题入口，方便移动用户快速访问精彩内容。',
  },
  {
    q: '热门漫画排行是如何评选的？',
    a: '热门漫画排行综合考量阅读量、收藏数、讨论热度和评分等多个维度，每周更新一次。通过真实读者数据反映当前最受欢迎的漫画作品。',
  },
  {
    q: '漫画分类有哪些？',
    a: '我们的漫画大全涵盖韩漫、日漫、国漫三大产区，每个产区内按热血、恋爱、奇幻、悬疑、搞笑、武侠、玄幻等类型进一步细分，方便你快速找到喜欢的漫画。',
  },
  {
    q: '可以推荐好看的韩漫吗？',
    a: '当然！我们的韩漫推荐栏目每日精选优质韩漫，从热门连载到小众佳作都有覆盖。你也可以通过首页的精选推荐和热门排行发现更多好看的韩漫作品。',
  },
];

export const cards = [
  {
    title: '《恶役只有死亡结局》',
    desc: '穿越成游戏反派，每一步选择都关乎生死。画风精美，剧情反转不断，韩漫推荐必看之作。',
    imageSeq: 'card-villainess',
    query: 'Beautiful Korean webtoon style villainess character in elegant gothic dress dramatic lighting rich jewel tones ornate palace background detailed illustration editorial quality artistic composition',
    tag: '韩漫推荐',
  },
  {
    title: '《葬送的芙莉莲》',
    desc: '时间对精灵和人类的不同意义，在旅途中重新理解友情的温暖。治愈系日漫大全经典之作。',
    imageSeq: 'card-frieren',
    query: 'Gentle fantasy illustration of an elven mage in a peaceful meadow journey theme warm golden hour lighting soft watercolor style serene atmosphere editorial composition with natural beauty',
    tag: '日漫大全',
  },
  {
    title: '《星辰变》',
    desc: '少年秦羽的修真之路，从凡人到掌控者。宏大的世界观和精彩的战斗场面，国漫排行榜常客。',
    imageSeq: 'card-xingchen',
    query: 'Epic Chinese xianxia fantasy illustration young cultivator ascending with starlight energy cosmic background traditional ink elements blended with modern digital art golden and emerald tones majestic composition',
    tag: '国漫排行榜',
  },
  {
    title: '《伯爵家的废物》',
    desc: '重生成为贵族家的废材少爷，用现代知识逆天改命。轻松搞笑与热血并存，热门漫画排行新秀。',
    imageSeq: 'card-count',
    query: 'Whimsical fantasy illustration of a noble young man in lavish mansion library setting mischievous expression warm candlelight atmosphere renaissance-inspired decor editorial quality with soft warm color palette',
    tag: '热门漫画排行',
  },
  {
    title: '《某天成为公主》',
    desc: '一觉醒来变成童话里的公主，但等待她的不是王子而是死亡危机。最新漫画连载中的人气黑马。',
    imageSeq: 'card-princess',
    query: 'Elegant fairy tale illustration of a princess in ornate gown standing in moonlit castle garden dreamy romantic atmosphere soft pink and ivory tones delicate details editorial composition with magical ambiance',
    tag: '最新漫画连载',
  },
];

export const indexItems = [
  { title: '韩漫推荐精选', count: 28, desc: '精心筛选的高质量韩漫作品合集', icon: 'ri-bookmark-line' },
  { title: '日漫大全分类', count: 35, desc: '按类型和年代分类的日漫完整目录', icon: 'ri-book-2-line' },
  { title: '国漫排行榜', count: 22, desc: '实时更新的国漫人气排名榜单', icon: 'ri-trophy-line' },
  { title: '热血战斗专区', count: 45, desc: '燃到爆的热血战斗类漫画合集', icon: 'ri-fire-line' },
  { title: '恋爱甜漫精选', count: 38, desc: '甜蜜治愈的恋爱类漫画推荐', icon: 'ri-heart-line' },
  { title: '悬疑推理专题', count: 20, desc: '烧脑悬疑推理类漫画精选', icon: 'ri-search-eye-line' },
  { title: '完结神作合集', count: 16, desc: '已经完结的高评分经典漫画', icon: 'ri-medal-line' },
];

export const mediaItems = [
  {
    title: '【漫评】为什么《我独自升级》能火遍全球？',
    desc: '深度解析韩漫天花板现象级作品的创作密码',
    duration: '15:28',
    imageSeq: 'media-solo',
    query: 'YouTube style thumbnail for anime review video featuring a powerful hunter character with glowing blue energy dark dramatic background with action effects bold title text area cinematic lighting professional video production style',
  },
  {
    title: '【盘点】2026上半年最值得追的10部韩漫',
    desc: '从热血到恋爱，总有一部适合你的追漫清单',
    duration: '12:45',
    imageSeq: 'media-top10',
    query: 'Video thumbnail style top 10 list with colorful Korean webtoon characters collage vibrant energetic composition modern graphic design elements bold typography space warm exciting atmosphere',
  },
  {
    title: '【对比】日漫vs韩漫vs国漫：三大漫画体系差异',
    desc: '从画风到叙事方式，全方位对比分析',
    duration: '18:32',
    imageSeq: 'media-compare',
    query: 'Split comparison video thumbnail showing Japanese Korean and Chinese comic art styles side by side educational concept clean modern layout distinct visual styles represented colorful engaging design professional quality',
  },
  {
    title: '【推荐】冷门但超好看的国漫宝藏作品',
    desc: '国漫排行榜之外的高质量隐藏佳作推荐',
    duration: '10:15',
    imageSeq: 'media-hidden',
    query: 'Video thumbnail with hidden gem treasure theme featuring Chinese manhua art elements warm inviting colors mysterious yet appealing atmosphere treasure chest concept creative editorial composition',
  },
  {
    title: '【解说】《剑尊归来》剧情全梳理：从开篇到最新话',
    desc: '一文看懂华山剑尊的复仇与成长之路',
    duration: '22:10',
    imageSeq: 'media-sword',
    query: 'Dramatic video thumbnail for martial arts manhwa review featuring a swordsman with flowing robes epic mountain backdrop dynamic action pose golden and crimson tones cinematic lighting professional production quality',
  },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '最新快讯', href: '#updates' },
  { label: '热门话题', href: '#topics' },
  { label: '分类索引', href: '#index' },
  { label: '漫迷视频', href: '#media' },
];